import { render, staticRenderFns } from "./TSRs.vue?vue&type=template&id=39f933ba"
import script from "./TSRs.vue?vue&type=script&lang=js"
export * from "./TSRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports